import React, { useEffect, useState } from "react";
import {
  Page,
  Text,
  View,
  Document,
  Image as ReactPdfImage,
} from "@react-pdf/renderer";
import Dayjs from "dayjs";

// Custom.
import { TemplateProps } from "../global";
import { styles } from "./styles";
import { baseStyles } from "../styles";
import I18n from "@vocollege/app/dist/modules/Services/I18n";
import { getContactName } from "@vocollege/app/dist/modules/VoHelpers";
import { convertSvgToImage } from "@vocollege/app/dist/modules/VoHelpers";
import LogoSvg from "@vocollege/theme/dist/images/vocollege.svg";

const LanguageRepresentativeDiplomaTemplate: React.FC<TemplateProps> = (
  props
) => {
  const { item } = props;
  const [logotype, setLogotype] = useState<any>(null);

  // Methods.
  const setImages = async () => {
    try {
      let convertedImage = await convertSvgToImage(LogoSvg, 100);
      setLogotype(convertedImage);
    } catch (error) {
      console.error(error);
    }
  };

  const getDate = () => {
    return item ? Dayjs(item.date).format("D MMMM YYYY") : "";
  };

  const getFormattedDate = (date: string) => {
    return Dayjs(date).format("D MMMM YYYY").toLocaleLowerCase();
  };

  // Effects.

  useEffect(() => {
    setImages();
  }, []);

  return (
    // @ts-ignore
    <Document>
      {/*
 // @ts-ignore */}
      <Page size="A4" style={(baseStyles.page, styles.page)} wrap={false}>
        <View style={styles.decor}>
          <View style={[baseStyles.section, styles.logoWrapper]}>
            <ReactPdfImage
              src="/images/sprakombud_utbildare_red.png"
              style={styles.logo}
            />
          </View>
          <View style={baseStyles.section}>
            <Text style={styles.title}>Diplom</Text>
          </View>
          <View style={baseStyles.section}>
            <Text style={styles.person}>
              {item &&
                (item.firstname || item.lastname) &&
                getContactName(item)}
            </Text>
          </View>
          <View style={[baseStyles.section, styles.subtitleWrapper]}>
            <Text style={styles.subtitle}>Diplomerad språkombudsutbildare</Text>
            <Text style={styles.centeredText}>
              har fullgjort utbildningen under perioden
            </Text>
            {item.course_moment && (
              <Text style={styles.centeredText}>
                {getFormattedDate(item.course_moment.start_date)} -{" "}
                {getFormattedDate(item.course_moment.end_date)}
              </Text>
            )}
          </View>
          <View style={[baseStyles.section, styles.block2]}>
            <Text style={styles.text}>
              Utbildningen ger teoretiska kunskaper och pedagogiska verktyg inom
              följande områden:
            </Text>
            <View style={[styles.text, baseStyles.listItem]}>
              <Text style={baseStyles.listItemDot}>&bull;</Text>
              <Text>
                Arbetsplatslärande och språkombudets roll på arbetsplatsen.
              </Text>
            </View>
            <View style={[styles.text, baseStyles.listItem]}>
              <Text style={baseStyles.listItemDot}>&bull;</Text>
              <Text>Didaktik för språkombudsutbildare.</Text>
            </View>
            <View style={[styles.text, baseStyles.listItem]}>
              <Text style={baseStyles.listItemDot}>&bull;</Text>
              <Text>Interkulturell kommunikation.</Text>
            </View>
            <View style={[styles.text, baseStyles.listItem]}>
              <Text style={baseStyles.listItemDot}>&bull;</Text>
              <Text>
                Kommunikativa dilemman på arbetsplatsen och hur de kan hanteras.
              </Text>
            </View>
            <View style={[styles.text, baseStyles.listItem]}>
              <Text style={baseStyles.listItemDot}>&bull;</Text>
              <Text>Reflekterande samtal.</Text>
            </View>
            <View style={[styles.text, baseStyles.listItem]}>
              <Text style={baseStyles.listItemDot}>&bull;</Text>
              <Text>
                Språkets roll i arbetslivet, för organisationen och individen.
              </Text>
            </View>
            <View style={[styles.text, baseStyles.listItem]}>
              <Text style={baseStyles.listItemDot}>&bull;</Text>
              <Text>
                Språkutvecklande respons på muntlig och skriftlig kommunikation.
              </Text>
            </View>
            <View style={[styles.text, baseStyles.listItem]}>
              <Text style={baseStyles.listItemDot}>&bull;</Text>
              <Text>
                Språkstimulerade övningar – en forskningsbaserad metod för
                språkutveckling.
              </Text>
            </View>
            <View style={[styles.text, baseStyles.listItem]}>
              <Text style={baseStyles.listItemDot}>&bull;</Text>
              <Text>Vuxnas andraspråksinlärning.</Text>
            </View>
          </View>

          <View style={[baseStyles.section, styles.block2]}>
            <Text style={styles.text}>
              Språkombudsutbildaren har också tillgodogjort sig innehållet i
            </Text>
            <Text style={styles.text}>Webbdel 1 - Tala, lyssna, förstå</Text>
            <Text style={styles.text}>Webbdel 2 - Läsa och skriva</Text>
            <Text style={styles.text}>
              Webbdel 3 - Telefonsamtal och handlingsplan
            </Text>
          </View>

          {item && item.place && item.place !== "" && (
            <View style={[baseStyles.section, styles.block3]}>
              <Text style={[styles.text, styles.date]}>
                {item.place}, {getDate()}
              </Text>
            </View>
          )}
          <View style={baseStyles.grow}></View>
          <View style={baseStyles.section}>
            <View style={styles.signatures}>
              {item && item.leader1 && (
                <View style={styles.signature}>
                  <Text style={styles.signaturePerson}>
                    {getContactName(item.leader1)}
                  </Text>
                  <Text style={styles.signatureTitle}>
                    {
                      I18n.get.languageRepresentativeEducatorDiploma.template
                        .leader
                    }
                  </Text>
                </View>
              )}
              {item && item.leader2 && (
                <View style={styles.signature}>
                  <Text style={styles.signaturePerson}>
                    {getContactName(item.leader2)}
                  </Text>
                  <Text style={styles.signatureTitle}>
                    {
                      I18n.get.languageRepresentativeEducatorDiploma.template
                        .leader
                    }
                  </Text>
                </View>
              )}
            </View>
          </View>
          <View style={[baseStyles.section, styles.footer]}>
            <Text style={styles.footerText}>
              Utbildningen har anordnats av Föreningen Vård- och omsorgscollege
            </Text>
            <View>
              {logotype && (
                <ReactPdfImage src={logotype} style={styles.footerLogo} />
              )}
            </View>
          </View>
          {item && item.uid && item.uid.code && (
            <Text style={[baseStyles.uid, styles.uid]}>{item.uid.code}</Text>
          )}
        </View>
      </Page>
    </Document>
  );
};
export default LanguageRepresentativeDiplomaTemplate;
